<template>
<div>
    <audio src="" preload hidden id="audio-dom"></audio>
    <div id="amap"></div>
    <mt-actionsheet :actions="audiolist" v-model="showAudioSelectBox"></mt-actionsheet>
</div>
</template>

<script>
import Apis from '../../config/apis'
import _ from '../../config/util'
import { Toast } from 'mint-ui'

// eslint-disable-next-line no-unused-vars
let timer = null

export default {
  name: 'AMap',
  props: {
    sid: String,
    uid: String,
  },
  data() {
    return {
      map: '', // 地图实例
      bounds: null, // 当前矩形范围
      tostNum: 0, // 当前提示不在范围内次数
      scenicList: [], // 景点列表
      markers: [], // 所有点的集合
      showDetail: false, // 是否显示详情弹框
      playStatus: false, // 当前播放状体
      hasPanorama: false, // 是否有全景图
      panoramaCenterLngLat: [], // 全景图中心点位置
      markerClustererObj: '', // 集合点对象
      infoWindow: null, // 信息窗口对象
      markerClustererArray: [], // 聚合点集合
      markerClustererNum: 0, // 聚合点绘制次数
      panoramaInfo: {}, // 全景图信息
      showAudioSelectBox: false, // 是否显示播放音乐弹框
      audiolist: [], // 当前语音列表
      curScenicElementNode: null, // 当前点击的音频播放按钮节点
      tcId: 0, // 图层ID
      userLocation: {}, // 用户当前位置
    }
  },
  // 获取全局数据
  computed: {
    curClassify() {
      return this.$store.state.curClassify
    },
    isNew() {
      return this.$store.state.isNew
    },
  },
  // 监听数据变化
  watch: {
    curClassify() {
      // 更新地图
      this.getScenicList()
    },
  },
  mounted() {
    // 地图初始化完毕后隐藏加载中动画
    document.getElementById('index-loading-box').className = 'index-loading-box hide'
  
    let ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      //   判断是微信环境，继续判断是否为小程序
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          this.registerWxApi()
        } else {
          // this.registerWxApi();
          this.registerH5Api()
        }
      })
    } else {
      this.registerH5Api()
    }

    // 获取图层ID
    this.tcId = this.$route.query.tcId ? this.$route.query.tcId : 0
    // 显示详情
    window.showDetail = () => {
      // 显示详情
      this.$store.commit('setDetailPopupStatus', true)
    }
    // 隐藏详情
    window.hideDetailFun = () => {
      // 显示详情
      this.$store.commit('setDetailPopupStatus', false)
    }

    // 播放音频
    window.playAudio = (e, url) => {
      const audio = document.getElementById('audio-dom')
      if (url.length == 1) {
        url[0]['el'] = e
        this.playAudio(url[0])
      } else {
        if (this.playStatus) {
          audio.pause()
          this.playStatus = false
          e.firstChild.nextElementSibling.style.display = 'none'
        } else {
          const audioShowList = []
          // 处理音频列表数据
          url.forEach((el) => {
            audioShowList.push({
              name: el.title,
              method: this.playAudio,
              el: e,
              url: el.url,
            })
          })
          this.audiolist = audioShowList
          // 存储当前点击的marker上的音频按钮节点
          this.curScenicElementNode = e
          this.showAudioSelectBox = true
        }
      }
    }
  },
  methods: {
    registerWxApi() {
      // 微信jssdk注册
      _.registerJSSDK(this.sid).then(() => {
          console.log('微信jssdk准备好了!')
          const url =
            'https://webapi.amap.com/maps?v=1.4.10&key=319dff1f55bf105417f400b42f61c8cc&plugin=AMap.MarkerClusterer&callback=amapCallback'
          const jsapi = document.createElement('script')
          jsapi.charset = 'utf-8'
          jsapi.src = url
          document.head.appendChild(jsapi)
        }).catch(err => {
          Toast({
            message: err
          })
        })
      // 地图加载回调函数
      window.amapCallback = () => {
        console.log('小程序端地图准备好了!')
        // 微信sdk注册成功执行
        window.uni.ready(() => {
          _.geolocation().then(res => {
            // // 存储用户位置
            // sessionStorage.setItem('userLocation', JSON.stringify([res.longitude, res.latitude]))
            // 设置全局用户位置
            this.$store.commit('setUserLocation', [
              res.longitude,
              res.latitude
            ])
            this.userLocation = [res.longitude, res.latitude]
            // 获取全景图
            this.getPanoramaInfo()
          })
        })
      }
  },
    /**
     * h5环境注册地图api
     */
    registerH5Api() {
      const url =
        'https://webapi.amap.com/maps?v=1.4.10&key=319dff1f55bf105417f400b42f61c8cc&plugin=AMap.MarkerClusterer&callback=h5amapCallback'
      const jsapi = document.createElement('script')
      jsapi.charset = 'utf-8'
      jsapi.src = url
      document.head.appendChild(jsapi)
      // 地图加载回调函数
      window.h5amapCallback = () => {
        console.log('h5端地图准备好了!')
        this.getCurrentPosition()
      }
    },
    getCurrentPosition() {
      let self = this
      AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000,
          // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
          buttonOffset: new AMap.Pixel(10, 20),
          // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          zoomToAccuracy: true,
          // 定位按钮的排放位置, RB表示右下
          buttonPosition: 'RB',
        })
        geolocation.getCurrentPosition()
        AMap.event.addListener(geolocation, 'complete', (e) => {
          console.log(e) // 定位成功之后做的事
          // 设置全局用户位置
          self.$store.commit('setUserLocation', [
            e.position.getLng(),
            e.position.getLat(),
          ])
          self.userLocation = [e.position.getLng(), e.position.getLat()]
          // 获取全景图
          self.panoramaInfo.url || self.getPanoramaInfo()

          // 定位成功之后再定位处添加一个marker
          // 　　　　　　　　var marker = new AMap.Marker({
          // 　　　　　　　　　　position: e.position, // （e.position）--->定位点的点坐标, position ---> marker的定位点坐标，也就是marker最终显示在那个点上，
          // 　　　　　　　　　　icon： '', // marker的图标，可以自定义，不写默认使用高德自带的
          // 　　　　　　　　　　map： self.map,  // map ---> 要显示该marker的地图对象
          // 　　　　　　　　})
        })
        AMap.event.addListener(geolocation, 'error', (e) => {
          console.log(e) // 定位失败做的事
          switch (e.info) {
            case 'PERMISSION_DENIED':
              Toast('浏览器阻止了定位操作！')
              break
            case 'POSITION_UNAVAILBLE':
              Toast('无法获得当前位置！')
              break
            case 'TIMEOUT':
              Toast('定位超时！')
              break
            case 'FAILED':
              console.log(
                '谷歌浏览器禁止了非安全域的定位请求,正在启用百度定位'
              )
              self.addressDetail()
              break
          }
        })
      })
    },
    addressDetail() {
      //获取地理位置
      var self = this
      //全局的this在方法中不能使用，需要重新定义一下
      var geolocation = new BMap.Geolocation()
      // 开启SDK辅助定位
      // geolocation.enableSDKLocation();
      //调用百度地图api 中的获取当前位置接口
      geolocation.getCurrentPosition(function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          //获取当前位置经纬度
          var myGeo = new BMap.Geocoder()
          myGeo.getLocation(
            new BMap.Point(r.point.lng, r.point.lat),
            function (result) {
              if (result) {
                //根据当前位置经纬度解析成地址
                console.log(result)
                // 设置全局用户位置
                self.$store.commit('setUserLocation', [
                  result.point.lng,
                  result.point.lat,
                ])
                self.userLocation = [result.point.lng, result.point.lat]
                // 获取全景图
                self.panoramaInfo.url || self.getPanoramaInfo()
              }
            }
          )
        }
      })
    },
    // 播放音频
    playAudio(data) {
      const audio = document.getElementById('audio-dom')
      audio.src = data.url
      if (this.playStatus) {
        audio.pause()
        this.playStatus = false
        data.el.firstChild.nextElementSibling.style.display = 'none'
      } else {
        audio.play()
        this.playStatus = true
        data.el.firstChild.nextElementSibling.style.display = 'block'
      }
      audio.addEventListener('ended', () => {
        this.playStatus = false
        data.el.firstChild.nextElementSibling.style.display = 'none'
      })
      // 隐藏弹框
      this.showAudioSelectBox = false
    },
    // 获取全景图
    getPanoramaInfo() {
      if (this.hasPanorama) return
      let getMultiMapUrl = Apis.getMultiMap
      if(this.sid) getMultiMapUrl = Apis.getMultiMap1
      this.axios
        .post(getMultiMapUrl, {
          sid: this.sid,
        })
        .then((res) => {
          if (this.tcId != 0) {
            res.data.forEach((el) => {
              if (el.id == this.tcId) {
                this.panoramaInfo = el
              }
            })
          } else {
            // 获取最小距离数据索引
            const minIx = _.calculatePointDistance(res.data, this.userLocation)
            this.panoramaInfo = minIx.toString() != '' ? res.data[minIx] : ''
          }
          // 存储全景信息
          this.$store.commit('setPanoramaInfo', this.panoramaInfo)
          this.hasPanorama = true
          // 地图初始化
          this.mapOption(this.panoramaInfo)
        })
    },
    // 获取当前位置
    curlocation() {
      const lngLat = new AMap.LngLat(...this.userLocation)
      if (this.hasPanorama) {
        // 判断是否在景区范围内
        if (this.bounds.contains(lngLat)) {
          // 清空之前的定位图标
          const userLocationMarker = this.$store.state.userLocationMarker
          if (userLocationMarker == '') {
            // 自定义标记点
            const content = '<div class="custor-marker"><div class="user-photo"></div></div>'
            const marker = new AMap.Marker({
              content: content,
              position: lngLat,
              // position: [113.568687, 23.057855],
              offset: new AMap.Pixel(-40, -80),
              map: this.map
            })
            this.$store.commit('setUserLocationMarker', marker)
          } else {
            userLocationMarker.setPosition(lngLat)
          }
          this.map.panTo(lngLat)
        } else {
          if (this.tostNum === 0) {
            if(window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') Toast(this.$t('main["当前不在景区范围内！"]'))
            this.tostNum += 1
          }
        }
      } else {
        const userLocationMarker = this.$store.state.userLocationMarker
        if (userLocationMarker == '') {
          // 自定义标记点
          const content = '<div class="custor-marker"><div class="user-photo"></div></div>'
          const marker = new AMap.Marker({
            content: content,
            position: lngLat,
            offset: new AMap.Pixel(-40, -80),
            map: this.map
          })
          this.$store.commit('setUserLocationMarker', marker)
        } else {
          userLocationMarker.setPosition(lngLat)
        }
      }
    },
    /**
     * 获取景点
     */
    getScenicList() {
      // const userPosition = sessionStorage.getItem('userLocation') ? JSON.parse(sessionStorage.getItem('userLocation')) : '';
      const userPosition = this.$store.state.userLocation
      // 没有用户坐标时先获取坐标在获取景点列表
      if (userPosition == '' || this.map == '') return
      this.getScenic(userPosition)
    },
    /**
     * 获取景点列表
     */
    getScenic(userPosition) {
      // 清空地图
      _.cleanMapOverlays(this).then(() => {
          this.markers = []
      })
      // 转换坐标 （使用百度接口转高德为百度坐标）
      const tramRes = _.bd_encrypt(userPosition[0], userPosition[1])
      const params = {
        cid: this.curClassify.id,
        classify_id: this.curClassify.id,
        sid: this.sid,
        lng: tramRes.lng,
        lat: tramRes.lat,
        uid: this.uid || this.$route.query.uid,
      }
      let spotsUrl = Apis.spots
      if(this.sid) spotsUrl = Apis.spots1
      this.axios.post(spotsUrl, params).then(async (res) => {
        // 最终结果
        const zzRes = []
        if (res.data?.length == 0) {
          await this.searchPois(this.curClassify.id).then((res) => {
            res.datas.map((el) => {
              var obj = {
                address: el.address,
                title: el.name,
                distance: (el.dis / 1000).toFixed(2) + 'km',
                lng: el.location.lng,
                lat: el.location.lat,
                telphone: el.tel,
                classify: el.classify,
                classifyid: el.classifyid,
                thumb: '',
                ctype: el.ctype,
                audio: [],
                question:el.question
              }
              zzRes.push(obj)
            })
          })
        } else {
          res.data.forEach((el) => {
            const result = _.bd_decrypt(el.lng, el.lat)
            // 将结果放入最终结果数组中
            el.lng = result.lng
            el.lat = result.lat
            // el.distance += 'km'
            zzRes.push(el)
          })
        }
        this.scenicList = zzRes
        // 设置当前选择的点
        this.$store.commit('setCurScenicItem', zzRes[0])
        this.$store.commit('setCurScenicList', zzRes)
        // 绘制点
        _.drawPoint(this)
      })
    } ,
    searchPois(cid) {
      return new Promise((resolve, reject) => {
        AMap.service(['AMap.PlaceSearch'], () => {
          var type, ctype
          switch (cid) {
            case '1':
              (type = '景点'), (ctype = 1)
              break
            case '2':
              (type = '餐饮服务'), (ctype = 2)
              break
            case '3':
              (type = '购物'), (ctype = 3)
              break
            case '4':
              (type = '住宿'), (ctype = 4)
              break
            case '5':
              (type = '洗手间'), (ctype = 0)
              break
            case '6':
              (type = '停车场'), (ctype = 0)
              break
            case '7':
              (type = '娱乐'), (ctype = 0)
              break
            case '9':
              (type = '加油站'), (ctype = 0)
              break
            default:
              type = '其他'
              break
          }

          //构造地点查询类
          var placeSearch = new AMap.PlaceSearch({
            type: type, // 兴趣点类别
            pageSize: 15, // 单页显示结果条数
            pageIndex: 1, // 页码
            // city: "010", // 兴趣点城市
            // citylimit: true,  //是否强制限制在设置的城市内搜索
            // map: this.map, // 展现结果的地图实例
            // panel: "amap", // 结果列表将在此容器中进行展示。
            // autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
          })

          // 获取景区信息
          const scenicInfo = this.$store.state.scenicInfo
          // 转换坐标
          const lnglatRes = _.bd_decrypt(scenicInfo.lng, scenicInfo.lat)
          var cpoint = [lnglatRes.lng, lnglatRes.lat] //中心点坐标
          //用户坐标
          const userPosition = this.$store.state.userLocation

          // 搜索范围
          var range = this.$store.state.scope ? this.$store.state.scope : 3000
          placeSearch.searchNearBy(
            '',
            cpoint,
            range,
            function (status, result) {
              // console.log('**result',result)
              var datas = result.poiList.pois.map((el) => {
                el.ctype = ctype
                el.classifyid = cid
                el.classify = cid == 2 ? '美食' : type
                el.dis = new AMap.LngLat(
                  userPosition[0],
                  userPosition[1]
                ).distance([el.location.lng, el.location.lat])
                return el
              })
              resolve({ datas })
            }
          )
        })
      })
    },
    // 地图init
    mapOption(data) {
      let map = null,
      mapOtherConfig = {}

      if(this.$route.query.scenicType === 'shiwaikanglv') {
        mapOtherConfig = {
          ...mapOtherConfig,
          viewMode:'3D',
          pitch: 50,
          rotation: -15,
        }
      }
      // let cityInfo = this.$store.state.cityInfo
      // const centerLngLat = (data && data.p_c) ? data.p_c.split(',') : [cityInfo.lng, cityInfo.lat]
      // 判断是否有全景区有则加载全景图没有则不加载
      if (data != '') {
        this.hasPanorama = true
        const centerLngLat = data.p_c.split(','),
        leftBottomLngLat = data.p_lb.split(','),
        // const leftBottomLngLat = data.p_lb.split(','),
        rightTopLngLat = data.p_rt.split(',')
        const zooms = [data.min - 1, data.max - 1]
        // 赋值全景区中心点位置
        this.panoramaCenterLngLat = centerLngLat
        // 实例化地图
        map = new AMap.Map('amap', {
          center: centerLngLat,
          zoom: data.default-1,
          zooms: zooms,
          resizeEnable: true,
          ...mapOtherConfig,
        })
        // 限制区域
        const lb = new AMap.LngLat(parseFloat(leftBottomLngLat[0]), parseFloat(leftBottomLngLat[1]))
        const rt = new AMap.LngLat(parseFloat(rightTopLngLat[0]), parseFloat(rightTopLngLat[1]))
        const bounds = this.bounds = new AMap.Bounds(lb, rt)
        // map.setLimitBounds(bounds);
        // 如果不是首页就不加载图层
        if (this.$route.name == 'Index') {
          // 判断使用的是图片图层还是使用切片图层
          if (data.type == 1) {
            // 图片图层
            const tilelayerThree = new AMap.ImageLayer({
              bounds: bounds,
              url: data.url,
              zIndex:105,
              zooms: zooms
            })
            map.setLayers([tilelayerThree,new AMap.TileLayer()])
          } else {
            // 切片图层
            const tilelayer = new AMap.TileLayer({
              zIndex: 105,
              opacity: 1,
              getTileUrl: (x, y, z) => {
                return `${data.url}${z}/tile-${x}_${y}.png`
              }
            })
            map.setLayers([tilelayer,new AMap.TileLayer()])
          }
        }
        // 监听地图缩放完成做限制提示
        map.on('zoomend', () => {
          const curZoom = map.getZoom()
          if (curZoom == data.min - 1) {
            Toast('当前已经到最小级别了哦！')
          }
          if (curZoom == data.max - 1) {
            Toast('当前已经到最大级别了哦！')
          }
        })
    } else {
        this.hasPanorama = false
        // 获取景区信息
        const scenicInfo = this.$store.state.scenicInfo
        // 转换坐标
        // const lnglatRes = _.bd_decrypt(centerLngLat[0], centerLngLat[1])
        const lnglatRes = _.bd_decrypt(scenicInfo.lng, scenicInfo.lat)
        // 实例化地图
        map = new AMap.Map('amap', {
          animateEnable: true,
          center: [lnglatRes.lng, lnglatRes.lat],
          zoom: 16,
          resizeEnable: true,
          rotateEnable: false,
          pitchEnable: false,
          ...mapOtherConfig,
        })
      }
      // 设置map对象
      this.map = map

      // 放大缩小地图按钮控件
      // 新版本不显示该组件
      if(!this.isNew) {
        map.plugin(['AMap.ToolBar'], function () {
          var tool = new AMap.ToolBar({
            position: 'RB',
            offset: new AMap.Pixel(15, 230),
            liteStyle: true,
          })
          map.addControl(tool)
        })
      }
      // 设置全局map对象
      this.$store.commit('setMapObj', map)
      // 监听地图点击时事件
      map.on('click', () => {
        // 关闭详情弹框
        this.$store.commit('setDetailPopupStatus', false)
        window.hidePOIBox() // 隐藏POI类型选择弹窗
      })
      // 监听地图平移事件
      map.on('mapmove', () => {
        // 关闭详情弹框
        this.$store.commit('setDetailPopupStatus', false)
      })
      // 地图图快加载完成后触发
      // map.on('complete', () => {
      //     console.log('AMap complete!');
      //     地图初始化完毕后隐藏加载中动画
      //     document.getElementById('index-loading-box').style.display = 'none';
      // })
      // 监听地图移动结束后
      // map.on('moveend', () => {
      //     map.remove(this.markerClustererArray)
      // })
      // 获取景点
      this.getScenicList()
      // 获取当前位置
      this.curlocation()
      // timer = setInterval(() => {
      //     this.curlocation()
      // }, 1000 * 60)
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
#amap {
  // height: calc(100vh - 1rem);
  height: 100vh;
  width: 100%;
  position: fixed;
  // top: 1rem;
  top: 0;
  left: 0;
}
</style>
